module.exports = __webpack_public_path__ + "static/media/no-signal-tv.fe41e6b2.svg";